module.exports = __webpack_public_path__ + "static/media/search.eab1173f.svg";